import {UPLOAD_MEDIA_ACCEPTED_EXTENSIONS} from '@/utils/constants/commonConstants';
import {TARGET_TYPES} from '@/utils/constants/saleTargetConstants';
import {
  MEDIA_PREVIEW_BANNER,
  MEDIA_PREVIEW_CARD
} from '@/components/organisms/MediaPreview/mediaPreviewConfig';

const IMAGE_MIME_TYPES = {
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.png': 'image/png',
  '.webp': 'image/webp'
};

export const SALES_TARGET_MEDIA_CONFIG = {
  acceptedTypes: [
    ...new Set(
      UPLOAD_MEDIA_ACCEPTED_EXTENSIONS.split(',').map(
        (extension) => IMAGE_MIME_TYPES[extension]
      )
    )
  ],
  maxSizeBytes: 500 * 1024,
  dimensions: null,
  aspectRatio: null,
  aspectRatioLabel: ''
};

export const PRODUCT_GROUP_QUANTITY_MEDIA_CONFIG = {
  ...SALES_TARGET_MEDIA_CONFIG,
  maxSizeBytes: 70 * 1024,
  dimensions: {width: 400, height: 170},
  colorMode: 'RGB'
};

const MAIN_TARGET_MEDIA_BASE = {
  ...SALES_TARGET_MEDIA_CONFIG,
  maxSizeBytes: 70 * 1024,
  colorMode: 'RGB',
  acceptedTypesLabel: 'WebP, JPG, PNG',
  descriptionPrefix: 'Required:'
};
export const MAIN_TARGET_FOREGROUND_MEDIA_CONFIG = {
  ...MAIN_TARGET_MEDIA_BASE,
  dimensions: {width: 400, height: 170}
};
export const MAIN_TARGET_BACKGROUND_MEDIA_CONFIG = {
  ...MAIN_TARGET_MEDIA_BASE,
  dimensions: {width: 72, height: 218}
};

export const SALES_TARGET_DISPLAY_CONTENT_CONFIG = [
  // {
  //   targetType: TARGET_TYPES.ProductTargetPrerequisite,
  //   version: 'v2',
  //   media: SALES_TARGET_MEDIA_CONFIG,
  //   foregroundPreviewType: MEDIA_PREVIEW_BANNER,
  //   backgroundPreviewType: MEDIA_PREVIEW_BANNER,
  //   foregroundPreviewScale: 0.5,
  //   backgroundPreviewScale: 0.5
  // },
  {
    targetType: TARGET_TYPES.MainTarget,
    version: 'v2',
    media: MAIN_TARGET_FOREGROUND_MEDIA_CONFIG,
    backgroundMedia: MAIN_TARGET_BACKGROUND_MEDIA_CONFIG,
    showBackgroundImage: true,
    foregroundPreviewType: MEDIA_PREVIEW_BANNER,
    backgroundPreviewType: MEDIA_PREVIEW_CARD,
    foregroundPreviewScale: 0.3,
    backgroundPreviewScale: 0.45
  },
  {
    targetType: TARGET_TYPES.ProductGroupQuantity,
    version: 'v2',
    media: PRODUCT_GROUP_QUANTITY_MEDIA_CONFIG,
    foregroundPreviewType: MEDIA_PREVIEW_BANNER,
    backgroundPreviewType: MEDIA_PREVIEW_BANNER,
    foregroundPreviewScale: 0.3,
    backgroundPreviewScale: 0.3
  },
  {targetType: TARGET_TYPES.RackChallenge, version: 'rack'}
];

export const getSalesTargetDisplayContentConfig = (targetType) =>
  SALES_TARGET_DISPLAY_CONTENT_CONFIG.find(
    (config) => config.targetType === targetType
  ) || {
    version: 'legacy',
    foregroundPreviewType: MEDIA_PREVIEW_BANNER,
    backgroundPreviewType: MEDIA_PREVIEW_BANNER,
    foregroundPreviewScale: 0.3,
    backgroundPreviewScale: 0.3
  };
